import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import ChevronIcon from "svg-icons/chevron-icon.js";
import { LabelLangString } from "component/LabelLang/label-lang.js";
import DataNotFound from "component/shared/DataNotFound/DataNotFound.jsx";

function RelatedPublications({ relatedPublications, currentLocale }) {
  return (
    <div
      className="box-ver-i mt-4"
      style={{ height: "300px", overflowY: "auto" }}
    >
      <h6>
        <FormattedMessage id="related-publications" />
      </h6>
      {relatedPublications?.length > 0 ? (
        relatedPublications.map(({ name, id, publicationTranslations }, i) => (
          <li key={i} className="list-unstyled">
            {id && (
              <Link
                to={`/publications/${id}`}
                onClick={() =>
                  ReactGA.event({
                    category: "Open",
                    action: "Open Publication",
                    label:
                      LabelLangString({
                        id: "name",
                        currentLocale,
                        defaultValue: name,
                        translations: publicationTranslations,
                      }) || id,
                    bulletin_id: id,
                    source: "related_bulletins",
                  })
                }
              >
                <ChevronIcon width={20} height={10} />{" "}
                {LabelLangString({
                  id: "name",
                  currentLocale,
                  defaultValue: name,
                  translations: publicationTranslations,
                })}
              </Link>
            )}
          </li>
        ))
      ) : (
        <DataNotFound />
      )}
    </div>
  );
}

export default RelatedPublications;
